import { React, useContext, useState, forwardRef, useImperativeHandle } from 'react';
import '../../css/Layout.css';
import Button from "@mui/material/Button";
import { FiMenu } from "react-icons/fi";
import { IoMdClose, IoMdMegaphone } from "react-icons/io";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { VscQuestion } from "react-icons/vsc";
import { FaArrowLeft } from "react-icons/fa6";
import { RiPoliceBadgeLine } from "react-icons/ri";
import { CgProfile } from "react-icons/cg";
import { MdMenuBook } from "react-icons/md";
import { RiChatAiLine } from "react-icons/ri";
import { useNavigate, Outlet } from "react-router-dom";
import axios from "axios";
import Nav from './Nav'
import LicenseModal from '../../common/LicenseModal';
import QuestionModal from '../../common/QuestionModal';
import ProfileModal from '../../common/ProfileModal';
import ChatModal from '../../common/ChatModal';

export const Header = ((ref) => {
  const navigate = useNavigate();
  const [navFlag, setNavFlag] = useState(false);
  const [isLicenseModalOpen, setLicenseModalOpen] = useState(false);
  const [isQuestionModalOpen, setQuestionModalOpen] = useState(false);
  const [isProfileModalOpen, setProfileModalOpen] = useState(false);
  const [isChatModalOpen, setChatModalOpen] = useState(false);
  
  const handleNavFlag = () => {
    // Nav Icon 클릭 시 Nav 열기/닫기 가능.
    setNavFlag(!navFlag);
  };

  const handleNavFlagFalse = () => {
    // Nav 밖에 다른곳을 클릭하면 자동으로 Nav 닫기.
    setNavFlag(false);
  };

  const handleLogout = () => {
    localStorage.setItem("LogoutType", 'C');
    navigate("/Logout");
  };

  const handleManual = async () => {
    const fileUrl = '/MES%20User%20Manual.pptx';

    try {
      // 💡 1. public 폴더에 파일이 존재하는지 가볍게(HEAD) 체크합니다.
      const checkRes = await fetch(fileUrl, { method: 'HEAD' });

      if (checkRes.ok) {
        // ✅ 2-A. 로컬(public)에 파일이 존재함 -> 즉시 다운로드 (빠름!)
        console.log("로컬(public)에서 매뉴얼을 다운로드합니다.");
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', 'MES User Manual.pptx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        // 🚨 2-B. 파일이 없음(404 등) -> 백엔드로 넘깁니다!
        console.log("로컬에 파일이 없어 내부에서 다운로드를 시도합니다.");
        await downloadFromBackend();
      }
    } catch (e) {
      // 네트워크 에러 등으로 로컬 체크 실패 시에도 백엔드 시도
      console.log("로컬 체크 중 에러 발생. 내부경로로 시도합니다.");
      await downloadFromBackend();
    }
  };

  // 💡 백엔드(GitHub) 통신용 서브 함수
  const downloadFromBackend = async () => {
    try {
      // 백엔드 API 호출 (아까 수정한 ExcelUploadController 아님, ManualDown 컨트롤러)
      const res = await axios.get('/api/Common/ManualDown', { 
        responseType: 'blob' 
      });

      // 헤더에서 파일명 파싱 (대소문자 방어)
      const cd = res.headers['content-disposition'] || res.headers['Content-Disposition'] || '';
      let filename = 'MES_사용자_매뉴얼.pptx'; 

      if (cd) {
        let m = cd.match(/filename\*=UTF-8''([^;]+)/i);
        if (m && m[1]) {
          filename = decodeURIComponent(m[1]);
        } else {
          m = cd.match(/filename="([^"]+)"/i) || cd.match(/filename=([^;]+)/i);
          if (m && m[1]) filename = m[1];
        }
      }

      // blob을 파일로 변환하여 다운로드
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
      const url  = window.URL.createObjectURL(blob);
      const a    = document.createElement('a');
      
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      
      document.body.appendChild(a);
      a.click();
      
      setTimeout(() => { 
        window.URL.revokeObjectURL(url); 
        document.body.removeChild(a); 
      }, 100);

    } catch (err) {
      console.error("백엔드 다운로드 실패:", err);
      alert('파일을 찾을 수 없거나 다운로드에 실패했습니다.');
    }
  };

  const goToMain = () => {
    return navigate(localStorage.getItem("main"));
  };


  const NavFlagChange = (value) => {

  }

  const licenseModalClose = () => {
    setLicenseModalOpen(false);
  }

  const questionModalClose = () => {
    setQuestionModalOpen(false);
  }

  const profileModalClose = () => {
    setProfileModalOpen(false);
  }

  const chatModalOpen = () => {
    setChatModalOpen(true);
  };

  const chatModalClose = () => {
    setChatModalOpen(false);
  };


  return (
    <>
    <header className="header">
        <div style={ { width: '100%' } }>
        
        {(localStorage.getItem("deviceType") === "A" || localStorage.getItem("deviceType") === "I" || localStorage.getItem("deviceType") === "M")? 
        <div className="NavIcon" onClick={handleNavFlag}>  {navFlag? (<FaArrowLeft size="30" />) : (<FiMenu size="30" />)}</div>
        :
        <div className="NavIcon" onClick={handleNavFlag}>  {navFlag? (<FaArrowLeft size="45" />) : (<FiMenu size="45" />)}</div>}
        &nbsp;&nbsp;
        {(localStorage.getItem("deviceType") === "A" || localStorage.getItem("deviceType") === "I" || localStorage.getItem("deviceType") === "M")? 
        <div onClick={goToMain} className="CompnayNM" style={ { paddingTop: '8px' } }>{ localStorage.getItem("company_nm") }</div>
        :
        <div onClick={goToMain} className="CompnayNM">{ localStorage.getItem("company_nm") }</div>}
        <div className="HeaderFunction">
          <div className="UserNM">{ localStorage.getItem("user_nm") }</div>
          <div className="ResourceNM">{ (localStorage.getItem("resource_name") !== '')? localStorage.getItem("resource_name"):"" }</div>
          <div className="BtnSet">
            <Button 
              onClick={()=> { setProfileModalOpen(true) }}
              sx={{  
                m: 1, 
                fontSize: 15, 
                color: "black", 
                borderColor: "black", 
                ":hover": { borderColor: "BLACK", backgroundColor: "BLACK", color: "white" }, 
              }} 
              variant="outlined" 
              startIcon={<CgProfile />}>
              프로필 수정
            </Button>

            <Button 
              onClick={()=> { setQuestionModalOpen(true) }}
              sx={{  
                m: 1, 
                fontSize: 15, 
                color: "black", 
                borderColor: "black", 
                ":hover": { borderColor: "#FFBB00", backgroundColor: "#FFBB00", color: "white" }, 
              }} 
              variant="outlined" 
              startIcon={<VscQuestion />}>
              1:1문의
            </Button>

            <Button 
              onClick={()=> { setLicenseModalOpen(true) }}
              sx={{  
                m: 1, 
                fontSize: 15, 
                color: "black", 
                borderColor: "black", 
                ":hover": { borderColor: "#3D63AE", backgroundColor: "#3D63AE", color: "white" }, 
              }} 
              variant="outlined" 
              startIcon={<RiPoliceBadgeLine />}>
              라이센스
            </Button>
            
            <Button 
              onClick={handleManual}
              sx={{  
                m: 1, 
                fontSize: 15, 
                color: "black", 
                borderColor: "black", 
                ":hover": { borderColor: "#40940fff", backgroundColor: "#40940fff", color: "white" }, 
              }} 
              variant="outlined" 
              startIcon={<MdMenuBook />}>
              매뉴얼
            </Button>
            
            <Button 
              onClick={chatModalOpen}
              sx={{  
                m: 1, 
                fontSize: 15, 
                color: "black", 
                borderColor: "black", 
                ":hover": { borderColor: "#aa1291ff", backgroundColor: "#aa1291ff", color: "white" }, 
              }} 
              variant="outlined" 
              startIcon={<RiChatAiLine />}>
              AI챗봇
            </Button>

            <Button 
                onClick={handleLogout}
                sx={{  
                  m: 1, 
                  fontSize: 15, 
                  color: "black", 
                  borderColor: "black", 
                  ":hover": { borderColor: "#FF4848", backgroundColor: "#FF4848", color: "white" }, 
                }} 
                variant="outlined" 
                startIcon={<RiLogoutBoxRLine />}>
              로그아웃
            </Button>
          </div>
        </div>
      </div>
      {isLicenseModalOpen && (<LicenseModal licenseModalClose={licenseModalClose} />)}
      {isQuestionModalOpen && (<QuestionModal questionModalClose={questionModalClose} />)}
      {isProfileModalOpen && (<ProfileModal profileModalClose={profileModalClose} />)}
      {isChatModalOpen && (<ChatModal chatModalClose={chatModalClose} />)}
    </header>
    <div style={ { position: 'relative', overflowY: 'auto', overflowX: 'hidden', width: '100%', minHeight: 'calc(100vh - 100px)', backgroundColor : 'white' } }>
        <Nav getNavFlag={navFlag} handleNavFlagFalse={handleNavFlagFalse} />
        <Outlet />
    </div>
    </>
  );
});

export default Header;